import { createContext } from 'react';
import type { AudioPlaybackStoreApi } from '../audio/useAudioPlaybackStore';
import type { VideoPlaybackStoreApi } from '../video/useVideoPlaybackStore';

export type PlaybackStoreApi = AudioPlaybackStoreApi | VideoPlaybackStoreApi;

export type PlaybackStoreContextValue = {
  store: PlaybackStoreApi | undefined;
  setStore: (store: PlaybackStoreApi | undefined) => void;
};

// Create raw context so we can have both throwing and non-throwing hooks
export const PlaybackStoreContext = createContext<PlaybackStoreContextValue | undefined>(undefined);
